import { FaRegTimesCircle } from "react-icons/fa";
import { useSearchBook } from "../shared/searchBook";
import { useState } from "react";
import { GetISBN13 } from '../../functions/AddBook';
import { AddBookToFirestore } from "../../functions/AddBook";
import "../../styles/bookSearch.css";
import {db,auth} from "../../firebase.js";
import { useAuthState } from "react-firebase-hooks/auth";
import { fetchAuthorName } from "../../functions/fetchAuthorName.js";
import {AddBookToAuthorPublishedBooks} from "../../functions/AddBookToAuthorPublishedBooks.js";
import { AddNewPublishedBook } from "./AddNewPublishedBook.js";
import { Link } from "react-router-dom";



const AddPublishedBooksModal = ({ show, onClose, user }) => {
  const [searchBook, setSearchBook] = useState(null);
  // const [user] = useAuthState(auth);
  const searchResults = useSearchBook(searchBook);
  const SearchBook = (e) => {
    e.preventDefault();
    setSearchBook(document.getElementById("book").value);
  };
  const handleBookClick = async(book) => {
    AddBookToFirestore(book, null);
    const AuthorName = await fetchAuthorName(user.uid);
    const AuthorsFromBook = book.volumeInfo?.authors;

    if (AuthorName && AuthorsFromBook.includes(AuthorName)) {
        await AddBookToAuthorPublishedBooks(user.uid, GetISBN13(book));
        console.log("Book added to Author's published books.");
      
  } else {
      console.log("AuthorName does not exist in AuthorsFromBook");
  }
  // onClose();
};
  return (
    <>
      <div className="flex items-center justify-center fixed top-0 left-0 right-0 bottom-0  bg-gradient-to-b from-maroon z-10">
        <div className="overlay-inner rounded-lg bg-lightcolor p-6 relative box-border ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600">
          <button className="close" onClick={onClose}>
            <FaRegTimesCircle />
          </button>
          <h2 className="text-xl pb-5 text-maroon">
            + Add your published books
          </h2>
          <form onSubmit={SearchBook}>
            <h4 className="text-base pb-2">Name of your book</h4>

            <div className="flex flex-col">
              <div>
                <input
                  type="text"
                  id="book"
                  placeholder="Enter the book name"
                  className="text-sm p-2"
                />
              </div>
              <div className="flex justify-center mt-3">
                <button
                  type="submit"
                  className="bg-maroon text-white p-2 rounded-full text-sm "
                >
                  Search
                </button>
              </div>
              {searchResults && (
                <div>
                  <h4>Search Results:</h4>
                  <ul>
                    {searchResults.map((book) => (
                      <li key={book.details.id}>
                        {console.log(book.details)}

                        <button
                          className="w-full"
                          onClick={() => handleBookClick(book.details)}
                        >
                          <div className="flex flex-row gap-6 border-y border-grey-500 hover:bg-lightmaroon">
                            <div>
                              <img
                                src={book.details.volumeInfo?.imageLinks?.smallThumbnail || 'No Thumbnail'}
                                alt={book.details.volumeInfo?.imageLinks?.smallThumbnail || 'No Thumbnail'}
                                className="h-16 w-14"
                              />
                            </div>
                            <div>
                              <div>Book Title: {book.details.volumeInfo.title}</div>
                              <div>Author(s): {book.details.volumeInfo?.authors ? book.details.volumeInfo.authors.join(', ') : 'Unknown Author'}</div>
                              <div>ISBN: {GetISBN13(book.details)}</div>
                            </div>
                          </div>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddPublishedBooksModal;
